declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const gtag = (...args: any[]) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  }
};

export const trackPageView = (url: string) => {
  gtag('config', 'G-BETC19V85X', {
    page_path: url,
  });
};

export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

// Eventos específicos para Canvasoft
export const analytics = {
  // Track page view
  trackPageView: (url: string) => {
    trackPageView(url);
  },
  // Usuario se loguea
  login: (method: string = 'google') => {
    trackEvent('login', 'auth', method);
  },

  // Usuario se desloguea  
  logout: () => {
    trackEvent('logout', 'auth');
  },

  // Ve una imagen en el visor
  viewImage: (imageId: string) => {
    trackEvent('view_item', 'gallery', imageId);
  },

  // Busca imágenes
  search: (searchTerm: string) => {
    trackEvent('search', 'gallery', searchTerm);
  },

  // Agrega a favoritos
  addToFavorites: (imageId: string) => {
    trackEvent('add_to_wishlist', 'favorites', imageId);
  },

  // Remueve de favoritos
  removeFromFavorites: (imageId: string) => {
    trackEvent('remove_from_wishlist', 'favorites', imageId);
  },

  // Agrega al carrito
  addToCart: (imageId: string, price: number) => {
    trackEvent('add_to_cart', 'cart', imageId, price);
  },

  // Remueve del carrito
  removeFromCart: (imageId: string) => {
    trackEvent('remove_from_cart', 'cart', imageId);
  },

  // Limpia carrito
  clearCart: () => {
    trackEvent('clear_cart', 'cart');
  },

  // Inicia proceso de compra
  beginCheckout: (items: any[], totalValue: number) => {
    trackEvent('begin_checkout', 'ecommerce', `${items.length}_items`, totalValue);
  },

  // Completa compra
  purchase: (orderId: string, totalValue: number, items: any[]) => {
    gtag('event', 'purchase', {
      transaction_id: orderId,
      value: totalValue,
      currency: 'USD',
      items: items.map(item => ({
        item_id: item.id,
        item_name: item.title,
        category: 'image',
        quantity: 1,
        price: item.price || 2.50 // fallback price
      }))
    });
  }
};